import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum AppMarketListingsServiceErrorCode {
  FailedToQueryMarketListing = 'FailedToQueryMarketListing',
}

class AppMarketListingsServiceError extends BaseError<AppMarketListingsServiceErrorCode> {
  state: Partial<{
    appDefinitionIds: string;
    serverStatus: string;
    errorName: string;
    errorMessage: string;
  }> = {};

  constructor(message: string, code: AppMarketListingsServiceErrorCode) {
    super(message, code, 'AppMarket Listings Service Error');
  }

  withAppDefinitionIds(appDefinitionIds: string[]) {
    this.state = {
      ...this.state,
      appDefinitionIds: appDefinitionIds.join(', '),
    };
    return this;
  }

  withServerStatus(serverStatus: number) {
    this.state = { ...this.state, serverStatus: serverStatus.toString() };
    return this;
  }

  withErrorName(errorName: string | undefined) {
    if (!errorName) {
      return this;
    }

    this.state = { ...this.state, errorName };
    return this;
  }

  withErrorMessage(errorMessage: string | undefined) {
    if (!errorMessage) {
      return this;
    }

    this.state = { ...this.state, errorMessage };
    return this;
  }
}

export const createAppMarketListingsServiceError = createErrorBuilder<
  AppMarketListingsServiceErrorCode,
  AppMarketListingsServiceError
>(AppMarketListingsServiceError);
